'use strict';

var _themeSections = require('@shopify/theme-sections');

require('../sections/product');

require('../sections/recommended-products');

(0, _themeSections.load)('*');